<template>
  <el-row :gutter="24">
    <el-col :span="20">
      <div class="auto_list">
        <div
          v-for="(item, index) in getContragentGroups"
          :id="item.id"
          :key="index"
        >
          <div class="auto_list-item">
            <el-row :gutter="24">
              <el-col :span="12">
                {{ item.name }}
              </el-col>
              <el-col :span="12">
                <div class="auto_list-actions">
                  <div class="auto_list-actions-scores">
                    <div class="center">
                      <img src="@/assets/img/big-truck.svg" alt />
                      <span>45</span>
                    </div>
                    <div class="center">
                      <img src="@/assets/img/small-user.svg" alt />
                      <span>49</span>
                    </div>
                    <div class="center">
                      <p @click="openDialogListContragent(item)">К спискам</p>
                    </div>
                    <div class="center">
                      <el-button
                        type="danger"
                        icon="el-icon-delete"
                        circle
                        @click="deleteGroup(item.id)"
                      />
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import {
  DELETE_CONTRAGENT_GROUP,
  FETCH_CONTRAGENT_GROUP,
} from '@/store/actions/contragentGroup'
import { mapGetters } from 'vuex'

export default {
  name: 'Group',
  computed: {
    ...mapGetters(['getContragentGroups']),
  },
  async created() {
    await this.$store.dispatch(FETCH_CONTRAGENT_GROUP)
  },
  methods: {
    openDialogListContragent(item) {
      this.$emit('openDialogListContragent', item)
    },
    async deleteGroup(id) {
      await this.$store.dispatch(DELETE_CONTRAGENT_GROUP, id)
    },
  },
}
</script>

<style scoped>
.auto_list-item {
  background: #ffffff;
  border-radius: 4px;
  box-shadow: 0px 2px 16px rgba(153, 155, 168, 0.12);
  padding: 20px;
  margin: 16px 0 13px 0;
}

.auto_list-item p {
  font-size: 20px;
  line-height: 24px;
  margin: 0;
}

.auto_list-actions-scores {
  display: flex;
  justify-content: space-around;
}

.center {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.center p {
  font-weight: bold;
  font-size: 12px;
  line-height: 14px;
  color: #3498db;
  border-radius: 5px;
}

.center p:hover {
  text-decoration: underline;
  cursor: pointer;
}

.center img {
  margin-right: 24px;
}

.center span {
  font-weight: bold;
}
</style>
